import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = ({ className = "" }) => {
  return (
    <div className={`loader-container ${className}`}>
      <div className="loader">
        <div className="text"><span>Sharp Physio</span></div>
        <div className="text"><span>Sharp Physio</span></div>
        <div className="text"><span>Sharp Physio</span></div>
        <div className="text"><span>Sharp Physio</span></div>
        <div className="text"><span>Sharp Physio</span></div>
        <div className="text"><span>Sharp Physio</span></div>
        <div className="text"><span>Sharp Physio</span></div>
        <div className="text"><span>Sharp Physio</span></div>
        <div className="text"><span>Sharp Physio</span></div>
        <div className="line"></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
